<template lang='pug'>
  include ../../../../pug/mixins/bem
  ui-click-outside(:do='hide')
    +b.ds-panel--space_xs.--space_md-xl.relative
      +e.element--offset_full
        slot(
          name='inputview',
          :keyup-event='dynamicSearch'
          :keydown-event='getFocus',
          :go-to-search='goToSearch'
          :reset='hide',
          :activated='activated',
          :show='show',
          :activeSearch='activeSearch',
        )
        +b.seacrh-result-wrapper
          +b.form-load(v-if='load')                
            loading
          transition-group(name="slidedown")
            
            +b.search-results(
              v-if='isAvailable(Object.keys(results)) && show', 
              key='results'
            )
              +b.list-search
                +e.preview.P {{ _('оберіть тему зі списку нижче') }}
                template(
                  v-for='(val, key) in results'
                ) 
                  template(
                    v-for='item in val'
                  )
                    component(
                      :is='key',
                      :item='item',
                      :fn='findValueAndHighlightTerm',
                      :fn_html='highlightTerm',
                      :localsearch='localsearch',
                      :trunc='truncateHtml'
                    )     
            +b.search-results(
              v-if='Object.keys(results).length && !isAvailable(Object.keys(results)) && show',
              key='withoutresults'
            )
              +b.list-search
                +e.preview.P {{ _('По вашему поисковому запросу ничего не найдено') }}

</template>
<script>


import VendorService from '@shared/services/vendor.js'
import { mapMutations, mapActions, mapState } from 'vuex'
const truncateHtml = require('html-truncate')
import {
  debounce,
  highlightTerm,
  findValueAndHighlightTerm,
} from '@shared/utils/helpers'

import Experts from './parts/experts'
import Faq from './parts/faq'
import Pages from './parts/pages'
import Products from './parts/products'
import Stages from './parts/stages'
import Videos from './parts/videos'

export default {
  name: 'SearchController',
  props: ['className', 'fieldId', 'url', 'localsearch'],
  components: {
    Experts,
    Faq,
    Pages,
    Products,
    Stages,
    Videos,
  },
  data() {
    return {
      // localsearch: '',
      show: false,
      arrowCounter: -1,
      empty: false,
      load: false,
      results: {},
      length: 1,
      meta: {
        
      }
    }
  },
  watch: {
    localsearch(nval, oval) {
      if (!nval) {
        this.hide()
      }
    },
    show(nval) {
      this.trigger_search(nval)
    },
  },
  computed: {
    activated() {
      return Object.keys(this.results).length || this.load || this.empty
    },
  },
  methods: {
    findValueAndHighlightTerm,
    highlightTerm,
    truncateHtml,
    ...mapMutations('search', [
      'SET_SEARCH',
    ]),
    ...mapActions('search', [
      'trigger_overlay',
      'trigger_search',
    ]),
    isAvailable(arr) {
      return arr.some(l => this.results[l].length)
    },
    hide() {
      this.reset()
      this.activeClass = false
      this.trigger_overlay(false)
    },
    reset() {
      this.results = {}
      this.clearClas = false
      this.empty = false
      this.activeClass = false
      this.arrowCounter = -1
      this.meta = {}
    },
    activeSearch() {
      this.show = !this.show
      if (this.show) {
        setTimeout(() => document.getElementById('inputsearch').focus(), 500) 
      }
    },
    clearSearch() {
      this.search = ''
    },
    showSearch() {
      if ('new-header-mobile-search' == this.className) {
        this.show = true
      } 
    },
    closeSearch(e) {
      console.log(e)
      if ('new-header-mobile-search' == this.className) {
        this.show = false
      } 
    },
    dynamicSearch(event) {
      console.log(event, 'event')
      if ('Enter' == event.code) { 
        
        this.goToSearch()
        return
      }
      let up = 38
      let down = 40
      let width = 1200
      if (window.innerWidth < width) {
        // this.localsearch = event.target.value
      }
      let limit = 2
      if (up !== event.keyCode && down !== event.keyCode) {
        if (this.localsearch.length < limit) return 
        this.load = true 

        this.debounceExecuter()

      } else {
        this.results = []
        this.empty = false
      }
    },
    debounceExecuter(parameters) {
      let time = 1000
      let action = debounce(this.executer, time)
      action(parameters)
    },
    executer(parameters) {
      VendorService.getSearch(this.localsearch).then(({ data }) => {
        this.trigger_overlay(true)
        this.results = data
        this.load = false
        this.empty = false
      })
     
    },
    goToSearch() {
      console.log(this.$store)
      this.trigger_overlay(false)
      if (window.is_main_page) {
        this.SET_SEARCH(this.localsearch)
      } else {
        window.location.pathname = `${window.baseUrl}filters/search=${this.localsearch}/`
      }
      this.reset()

    },
    onEnter() {
      this.arrowCounter = -1
      this.goToSearch()
    },
    getFocus(event) {
      // console.log(event)
      if ( 'Enter' == event.code) { 
        this.reset()
        return
      }
      let i = 0
      let one = 1
      let zero = 0
      if (this.results.length > i) {
        if ('ArrowDown' === event.code) {
          this.$refs['search-link'][i].focus()
        }
        document.addEventListener('keydown', e => {
          if ('ArrowDown' === e.code && this.arrowCounter < this.results.length - one) {
            e.preventDefault()
            this.arrowCounter = this.arrowCounter + one
            this.$refs['search-link'][this.arrowCounter].focus()
          }
          if ('ArrowUp' === e.code && this.arrowCounter > zero) {
            e.preventDefault()
            this.arrowCounter = this.arrowCounter - one
            this.$refs['search-link'][this.arrowCounter].focus()
          }
        })
      }
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/js/shared/components/search/Controller.vue